import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  emailOtp: yup
    .string()
    .matches(/^\d{6}$/, 'OTP must be a 6-digit number') // Example: Ensures OTP is 6 digits
    .required('OTP is required'),
  mobile:yup
  .string()
  .matches(/^\d{6}$/, 'OTP must be a 6-digit number') // Example: Ensures OTP is 6 digits
  .required('OTP is required'),
});

